<template>
  <div class="container">
    <div class="checkout-header">
      <div class="checkout-header-head">
        <h1 class="entry-title" v-text="$t('route.checkout')" />
      </div>
      <div class="checkout-header-breadcrumbs">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }" v-text="$t('route.home')" />
            </li>
            <li class="breadcrumb-item active" aria-current="page" v-text="$t('route.checkout')"></li>
          </ol>
        </nav>
      </div>
    </div>

    <!-- login -->
    <!-- <login v-if="!user.isLoggedIn" :openLoginForm="openLoginForm" :submit="submitLogin" /> -->
    <!-- coupon -->
    <coupon v-model="couponCode" :openCouponForm="openCouponForm" :submit="submitCoupon" />

    <div class="checkout-main">
      <div class="d-flex flex-wrap">
        <div class="col-12 col-sm-8 col-md-8">
          <billing-info :churchOrder="churchOrder" v-model="user" />
        </div>
        <div class="col-12 col-sm-4 col-md-4">
          <div class="order-detail">
            <h4>Your order</h4>
            <div class="order-detail-content">
              <order-detail :couponInfo="couponInfo" :churchOrder="churchOrder" :extraTrial="getExtraTrial" />

              <recurly :recurlyCardError="recurlyCardError" :user="user" />

              <TAC />

              <div class="button">
                <a href="javascript:void(0)" @click.prevent="submitSignUp">Sign Up Now</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLongDate } from '@/utils/date'
import loadScript from '@/utils/dynamicLoadScript'
import { isEmpty, includes, get, map } from 'lodash'
import { mapState } from 'vuex'
import checkoutService from '@/services/CheckoutService'
// import Login from './Login'
import Coupon from './Coupon'
import OrderDetail from './OrderDetail'
import Recurly from './Recurly'
import TAC from './TAC'
import BillingInfo from './BillingInfo'

export default {
  name: 'checkout',
  data: () => ({
    couponCode: '',
    isYearlyPlan: false,
    churchOrder: {},
    couponInfo: {},
    recurlyCardError: '',
    couponType: ['free_trial', 'percent']
  }),
  components: {
    TAC,
    // Login,
    Coupon,
    OrderDetail,
    Recurly,
    BillingInfo
  },
  computed: {
    ...mapState({
      user: 'user'
    }),
    getExtraTrial() {
      const date = new Date()
      date.setMonth(date.getMonth() + 1)
      return getLongDate(date)
    }
  },
  async created() {
    // if (isEmpty(this.user)) {
    //   this.$router.push({ name: 'login' })
    // }
    const plancycle = $.cookie('plancycle')
    if (!isEmpty(plancycle)) {
      this.isYearlyPlan = plancycle === 'year'
      this.churchOrder = {
        price: this.isYearlyPlan ? Number($.cookie('yearly')) : Number($.cookie('monthly')),
        planCode: this.isYearlyPlan ? $.cookie('planYearly') : $.cookie('planMonthly'),
        plancycle: plancycle
      }
      await this.initRecurly()
    } else {
      this.$router.push({ name: 'pricing' })
    }
  },
  watch: {
    couponCode: {
      handler(val) {
        if (isEmpty(val)) {
          this.couponInfo = {}
        }
      },
      immediate: true
    }
  },
  methods: {
    isEmpty,
    async validateCouponRecurly() {
      if (!isEmpty(this.couponCode)) {
        try {
          const resp = await recurly
            .Pricing()
            .plan(this.churchOrder.planCode)
            .coupon(this.couponCode)
          const couponType = get(resp, 'discount.type', '')
          if (isEmpty(resp) || !includes(this.couponType, couponType)) {
            this.couponInfo = {}
            this.$toasted.show('Coupon invalid').goAway(5000)
          } else {
            if (couponType === 'percent') {
              this.couponInfo = {
                type: couponType,
                amount: get(resp, 'discount.rate', 0) * 100,
                unit: '%'
              }
            } else {
              this.couponInfo = get(resp, 'discount.trial', {})
            }

            this.$toasted.show('Coupon applied').goAway(5000)
            $('#checkout_coupon').slideToggle(400)
          }
        } catch (error) {
          console.error({ error })
          this.$toasted.show(get(error, 'message', 'Coupon invalid')).goAway(5000)
          this.couponInfo = {}
        }
      }
    },
    async initRecurly() {
      loadScript('recurly', 'https://js.recurly.com/v3/recurly.js', err => {
        if (err) {
          console.error(err)
          throw err
        }
        if (recurly && !recurly.configured) {
          recurly.configure('ewr1-QpGBXdpUjZM19khLqGvI9x')
        }
        return
      })
    },
    checkoutRecurly() {
      return new Promise((resolve, reject) => {
        const form = $('#payment-method')
        recurly.token(form, err => {
          if (!isEmpty(err)) {
            console.error({ err })
            this.recurlyCardError = `${this.$t('checkout.errorCard.title')} ${map(err.fields, field => this.$t('checkout.errorCard.' + field)).join(', ')}`
            this.$toasted.show(this.recurlyCardError).goAway(5000)
            $('html, body').animate({ scrollTop: $('#payment-method').offset().top }, 'slow')
            reject()
          } else {
            resolve()
          }
        })
      })
    },
    openCouponForm() {
      $('#checkout_coupon').slideToggle(400, () =>
        $('#checkout_coupon')
          .find(':input:eq(0)')
          .focus()
      )
    },
    openLoginForm() {
      $('#checkout_login').slideToggle(400, () =>
        $('#checkout_login')
          .find(':input:eq(0)')
          .focus()
      )
    },
    async submitCoupon() {
      await this.validateCouponRecurly()
    },
    submitLogin() {
      const dataInput = $('#login-info')
        .serializeArray()
        .reduce(function(obj, item) {
          obj[item.name] = item.value
          return obj
        }, {})
      const { email, password } = dataInput

      this.$store.dispatch('login', [email, password])
    },
    async submitSignUp() {
      const forms = document.getElementsByClassName('needs-validation')
      let isValid = true
      Array.prototype.forEach.call(forms, function(form) {
        if (form.checkValidity() === false) {
          isValid = false
        }
        form.classList.add('was-validated')
      })
      if ($('#password').val() !== $('#passwordConfirmation').val()) {
        $('#passwordConfirmation')[0].style.borderColor = 'red'
        this.$toasted.show('Password do not match.').goAway(5000)
        $('html, body').animate({ scrollTop: $('#billing-info').offset().top }, 'slow')
        return
      } else if (!isValid) {
        this.$toasted.show('Please fill out the payment form.').goAway(5000)
        $('html, body').animate({ scrollTop: $('#billing-info').offset().top }, 'slow')
        return
      } else {
        if ($('#terms').prop('checked')) {
          const checkoutRequired = [
            'password',
            'plan',
            'church_name',
            'phone',
            'city',
            'address_1',
            'address_2',
            'state',
            'country',
            'postcode',
            'email',
            'billing_first_name',
            'billing_last_name',
            'recurly_code'
          ]
          const billingData = $('#billing-info')
            .serializeArray()
            .reduce(function(obj, item) {
              if (includes(checkoutRequired, item.name)) {
                obj[item.name] = item.value
              }
              return obj
            }, {})

          delete billingData.passwordConfirmation
          try {
            await this.checkoutRecurly()
            const paymentData = $('#payment-method')
              .serializeArray()
              .reduce(function(obj, item) {
                if (includes(checkoutRequired, item.name)) {
                  obj[item.name] = item.value
                }
                return obj
              }, {})
            const dataSubmit = {
              ...paymentData,
              ...billingData
            }
            if (!isEmpty(this.couponInfo)) {
              dataSubmit['coupon_code'] = this.couponCode
            }

            const resp = await checkoutService.doCheckout(dataSubmit)
            this.recurlyCardError = ''
            this.$toasted.show('Sign up successful').goAway(5000)
            window.location.href = 'https://mytruelife.org'
          } catch (error) {
            if (error.response.status === 422) {
              this.recurlyCardError = 'the email has already been taken'
              this.$toasted.show(this.recurlyCardError).goAway(5000)
              $('#loginbox')[0].scrollIntoView()
            } else if (get(error, 'response.status') === 402) {
              this.recurlyCardError = error.response.data
              this.$toasted.show(this.recurlyCardError).goAway(5000)
              $('html, body').animate({ scrollTop: $('#payment-method').offset().top }, 'slow')
            } else {
            }
            console.error({ error })
          }
        } else {
          this.$toasted.show('Please agree to terms and conditions.').goAway(5000)
        }
      }
    }
  }
}
</script>
<style lang="scss">
.checkout-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &-head {
    color: #2ba349;
    .entry-title {
      font-size: 52px;
      line-height: 62px;
    }
  }
  &-breadcrumbs {
    .breadcrumb {
      font-weight: 300;
      color: #adb0b6;
      font-size: 13px;
      line-height: 25px;
      text-transform: none;
      background-color: transparent;
      padding: 3px 12px 2px 12px;
      margin: 0;
      &-item {
        &.active,
        &::before {
          color: #adb0b6;
        }
      }
      a {
        color: #adb0b6;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

.checkout-coupon {
  font-size: 15px;
  line-height: 28px;
  &-info {
    text-align: center;
    .showcoupon-tag {
      font-weight: 700;
      color: #3b3f4a;
      text-transform: uppercase;
      display: inline-block;
      margin-right: 10px;
      i {
        margin-right: 5px;
        font-size: 18px;
      }
    }
    a {
      font-size: 14px;
      color: #2ba048;
      font-weight: 700;
    }
  }

  .button {
    display: inline-block;
    margin: auto;
    height: 38px;
    a {
      color: #fff;
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      padding: 9px 16px;
      border-radius: 2px;
      background-color: #2ba048;
      text-transform: uppercase;
      &:hover {
        background-color: #6ab165;
      }
    }
  }
  #checkout_coupon,
  #checkout_login {
    word-spacing: normal;
    color: #787d85;
    background-color: #f8f8f9;
    border-radius: 2px;
    margin: auto;
    padding: 30px 30px 20px;
    margin-top: 25px;
    > div {
      display: flex;
      flex-flow: row wrap;
      .coupon {
        margin-right: 20px;
        margin-bottom: 10px;
        flex: 1 1 auto;
        position: relative;
        &::before {
          position: absolute;
          content: '\f02b';
          font-family: 'FontAwesome';
          left: 15px;
          top: 6px;
          font-size: 18px;
          line-height: 26px;
        }
        input {
          height: 38px;
          width: 100%;
          color: #787d85;
          padding-left: 35px;
          &::placeholder {
            color: #787d85;
          }
        }
      }
    }
  }
  #checkout_login {
    form {
      display: flex;
      flex-direction: column;
      span {
        position: relative;
        margin-bottom: 10px;
        &::before {
          position: absolute;
          font-family: 'FontAwesome';
          left: 15px;
          top: 6px;
          font-size: 18px;
          z-index: 10;
          line-height: 26px;
        }
        &.username::before {
          content: '\f007';
        }
        &.password::before {
          content: '\f13e';
        }
        input {
          width: 100%;
          padding-left: 35px;
          &::placeholder {
            color: #787d85;
          }
        }
      }
    }
  }
}

.checkout-main {
  color: #3b3f4a;
  margin-top: 20px;
  .order-detail {
    background-color: #f8f8f9;
    padding: 30px;
    h4 {
      font-size: 20px;
      line-height: 30px;
      font-weight: 600;
    }
    &-content {
      .cart_item {
        font-size: 14px;
        line-height: 26px;
        color: #787d85;
        padding: 10px 0;
        border-top: 1px solid #adb0b6;
        &:first-child {
          border-top: none;
        }
        &.total {
          .price {
            font-size: 20px;
            line-height: 30px;
          }
        }
        p {
          font-weight: 300;
          font-size: 15px;
          line-height: 28px;
          margin: 0;
          &:nth-child(2) {
            color: #adb0b6;
            .price {
              color: #3b3f4a;
              font-weight: 700;
            }
          }
        }
        small {
          color: #787d85;
        }
        &.payment {
          .payment-method {
            display: inline-block;
            width: 35px;
            margin-right: 10px;
            img {
              vertical-align: middle;
              margin: -2px 0.5em 0;
            }
          }
          #payment-method {
            .cardError {
              color: red;
              font-size: 14px;
            }
          }
        }
      }
      .term-and-condition {
        margin-top: 30px;
        .term-and-condition-text {
          p,
          label {
            font-size: 13px;
            line-height: 25px;
            a {
              color: #2ba048;
            }
          }
          label {
            text-transform: uppercase;
          }
        }

        .tac-modal {
          .modal-dialog {
            max-width: 95vw;
            margin-top: 50px;
            .modal-content {
              padding: 10px;
              max-height: 90vh;
              overflow: auto;
              h2 {
                text-align: center;
                word-break: break-word;
              }
            }
          }
          button.close {
            cursor: pointer;
            position: absolute;
            right: 10px;
            top: 10px;
            width: 32px;
            opacity: 1;
          }
        }
      }
      .button {
        a {
          text-align: center;
          display: block;
          width: 100%;
          color: #fff;
          margin-top: 20px;
          font-size: 14px;
          line-height: 16px;
          font-weight: 500;
          padding: 16px 0;
          border-radius: 2px;
          background-color: #2ba048;
          text-transform: capitalize;
          &:hover {
            background-color: #6ab165;
          }
        }
      }
    }
  }
  #billing-info {
    .row {
      margin-bottom: 10px;
    }
  }

  form {
    @media (min-width: 575.98px) {
      .col-md-6,
      .col-6 {
        max-width: 48%;
      }
    }
    .row {
      margin: 0;
      &.password,
      &.fullname,
      &.exp_date {
        justify-content: space-between;
      }
      &.address {
        input {
          margin-bottom: 10px;
        }
      }
    }
    .col-6 {
      max-width: 48%;
    }
    .col-12,
    .col-6,
    .col-sm-6,
    .col-md-6 {
      padding: 0;
    }
    input {
      width: 100%;
      padding-left: 15px;
      border-radius: 0;
      &::placeholder {
        font-size: 14px;
        color: #bfb9d1;
      }
      &.form-control:invalid,
      &.form-control:valid,
      &.form-control {
        &:hover,
        &:focus {
          box-shadow: none;
        }
      }
    }
    label {
      display: block;
      width: 100%;
      margin-top: 0.5rem;
      margin-bottom: 0;
    }
  }
}
</style>
